import axios from 'axios'

export default function getGeoJSON(url) {
  let params = {}

  return axios.get(url, {
    params: params,
  })
}



// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/services/getGeoJSON.js